module.exports = __webpack_public_path__ + "static/media/datawin-mastercard-secure.437b306e.png";